import { DropDownItem } from "../../forms/components/dropdown/dropdown-item.model";
import { AuditMetadata, Location } from "../../core/core";
import { InventoryItemSummary } from "../../inventory/inventory";

export interface InspectionDefinition {
  currentSectionIndex: number;
  dateCreated: string; // only used for front end purposed
  catalogId?: string;
  typeDefinitionId?: string;
  inspectionType: InspectionType;
  externalType: string;
  account?: any;
  userId: string;
  user: any; // index
  metadata: any;
  localMetadata: any;
  sections: InspectionSection[];
  auditMetadata: AuditMetadata;
  id: string;
  isActive: boolean;
  itemType: string[];
  partitionKey: string;
  startTime: Date;
  endtime: Date;
  totalTime: any;
  inventoryItem: InventoryItemSummary;
  location: Location;
  status: string;
  progress: "Incomplete" | "Complete";
  alerts: InspectionAlert[];
  createdDateTime: string; // index
}

export interface InspectionAlert {
  severity: "Info" | "Warning" | "Error";
  message: string;
}

export interface InspectionInput {
  jsonPatchPath: string;
  stepId: string; // used for uploading media to make it easier
  inputType?: "Photo" | "Text" | "TextArea" | "Video" | "Barcode" | "Dropdown";
  value?: any;
  name?: string;
  instruction?: string;
  requirement?: "FailOnly" | "Optional" | "OptionalFailRequired" | "Always";
  storedImage?: any;
  videoStorage: any;
  id: any;
  isActive: boolean;
  show: boolean;
  mediaPath?: string; // blob url
  items: [{ [key: string]: string }];
  dropdownItems: DropDownItem[];
  expectedImageOrientation?: "Landscape" | "Portrait"; //clientside
  expectedImageOrientationMessage?: string; // clientside
}

export interface InspectionAcknowledgement {
  description: string;
  answer: string;
  icon?: any;
}

export interface InspectionStep {
  internalNotes: string;
  jsonPatchPath: string;
  stepType:
    | "Generic"
    | "BoolStep"
    | "AcknowledgementStep"
    | "MultiAcknowledgementStep"
    | "VerificationStep"
    | "TelematicsStep"
    | "RubblTagStep"
    | "DataCollection";
  telematicsId?: any;
  title: string;
  helpText?: string;
  positiveLabel?: string;
  negativeLabel?: string;
  persona?: InspectionPersona;
  inputs?: InspectionInput[];
  answer?: any;
  expectedValue?: string;
  value?: any;
  acknowledgements?: InspectionAcknowledgement[];
  acknowledgement?: InspectionAcknowledgement;
  id?: any;
  isActive: boolean;
  hide: boolean; // clientside
  hasNotes: boolean; // clientside
}

export interface InspectionSection {
  jsonPatchPath: string;
  internalNotes: string;
  hasFailures: boolean; // client side
  index: number; // client side, used to keep track
  complete: boolean; // client side, used to to show what section is completed in the checkout
  inProgress: boolean; // client side, used to track what section is in progress
  inspectionSteps: InspectionStep[];
  steps: InspectionStep[]; // from api
  title: string;
  image?: any;
  continueText: string;
  id?: any;
  isActive: boolean;
  images: string[];
}

export enum InspectionType {
  Onboarding = "Onboarding",
  OnboardingAttachment = "OnboardingAttachment",
  CheckinCheckout = "CheckinCheckout",
  Maintenance = "Maintenance",
  Generic = "Generic", // basically like onboarding, not used yet
}

export enum InspectionPersona {
  Owner = "Owner",
  Renter = "Renter",
  Maintenance = "Maintenance",
}

export interface InspectionMediaResponse {
  id: string;
  storagePath: string;
}
